const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./dialog-Bckxd7dC.js","./component-BFVg3Q7H.js","./utilities-BToXpjgA.js","./events-C4hlH4zR.js","./dialog-DRtaxTPO.css","./carousel-embla-DWvH-wV-.js","./embla-DjVGOkZN.js","./predictive-search-C5KMDIlc.js","./morph-Dbl7pzBf.js","./kaching-bundle-price-BbvRfB2p.js"])))=>i.map(i=>d[i]);
import "./liquid-ajax-cart-BmMsxgPD.js";
import { C as CartUpdateEvent, b as CartErrorEvent, c as CartAddEvent } from "./events-C4hlH4zR.js";
import { f as formatMoney } from "./utilities-BToXpjgA.js";
const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled = function(promises$2) {
      return Promise.all(promises$2.map((p) => Promise.resolve(p).then((value$1) => ({
        status: "fulfilled",
        value: value$1
      }), (reason) => ({
        status: "rejected",
        reason
      }))));
    };
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector("meta[property=csp-nonce]");
    const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
    promise = allSettled(deps.map((dep) => {
      dep = assetsURL(dep, importerUrl);
      if (dep in seen) return;
      seen[dep] = true;
      const isCss = dep.endsWith(".css");
      const cssSelector = isCss ? '[rel="stylesheet"]' : "";
      if (!!importerUrl) for (let i$1 = links.length - 1; i$1 >= 0; i$1--) {
        const link$1 = links[i$1];
        if (link$1.href === dep && (!isCss || link$1.rel === "stylesheet")) return;
      }
      else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) return;
      const link = document.createElement("link");
      link.rel = isCss ? "stylesheet" : scriptRel;
      if (!isCss) link.as = "script";
      link.crossOrigin = "";
      link.href = dep;
      if (cspNonce) link.setAttribute("nonce", cspNonce);
      document.head.appendChild(link);
      if (isCss) return new Promise((res, rej) => {
        link.addEventListener("load", res);
        link.addEventListener("error", () => rej(/* @__PURE__ */ new Error(`Unable to preload CSS for ${dep}`)));
      });
    }));
  }
  function handlePreloadError(err$2) {
    const e$1 = new Event("vite:preloadError", { cancelable: true });
    e$1.payload = err$2;
    window.dispatchEvent(e$1);
    if (!e$1.defaultPrevented) throw err$2;
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
let initialized = false;
function initLiquidAjaxCartEventsBridge() {
  if (initialized) {
    return;
  }
  initialized = true;
  document.addEventListener("liquid-ajax-cart:init", () => {
    const cart = window.liquidAjaxCart?.cart ?? null;
    document.dispatchEvent(
      new CartUpdateEvent(cart, "liquid-ajax-cart:init", {
        source: "liquid-ajax-cart",
        itemCount: cart?.item_count ?? 0
      })
    );
  });
  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail;
    const cart = window.liquidAjaxCart?.cart ?? null;
    const isSuccess = requestState.responseData?.ok;
    if (!isSuccess || requestState.fetchError) {
      const errorData = requestState.responseData?.body ?? {};
      document.dispatchEvent(
        new CartErrorEvent(
          "liquid-ajax-cart",
          errorData.message ?? requestState.fetchError ?? "Cart request failed",
          errorData.description ?? null,
          errorData.errors ?? null
        )
      );
      return;
    }
    const eventData = {
      source: "liquid-ajax-cart",
      requestType: requestState.requestType,
      itemCount: cart?.item_count ?? 0,
      sections: requestState.requestBody?.sections ?? null
    };
    if (requestState.requestType === "add") {
      document.dispatchEvent(new CartAddEvent(cart, "liquid-ajax-cart", eventData));
    } else {
      document.dispatchEvent(new CartUpdateEvent(cart, "liquid-ajax-cart", eventData));
    }
  });
}
let syncInProgress = false;
function getFeeVariantId() {
  const el = document.querySelector("[data-engraving-fee-variant-id]");
  const raw = el?.dataset.engravingFeeVariantId;
  const id = raw ? parseInt(raw, 10) : NaN;
  return Number.isNaN(id) ? null : id;
}
function hasEngravingProperty(item) {
  if (!item.properties) {
    return false;
  }
  const val = item.properties["Gravur"] ?? item.properties["Engraving"] ?? null;
  return typeof val === "string" && val.trim().length > 0;
}
async function syncFeeQty() {
  if (syncInProgress) {
    return;
  }
  const feeVariantId = getFeeVariantId();
  if (!feeVariantId) {
    return;
  }
  const cart = window.liquidAjaxCart?.cart;
  if (!cart?.items) {
    return;
  }
  const feeLines = cart.items.filter((i) => i.variant_id === feeVariantId);
  const walletLines = cart.items.filter((i) => i.variant_id !== feeVariantId);
  const targetQty = walletLines.filter(hasEngravingProperty).length;
  const currentQty = feeLines.reduce((sum, i) => sum + i.quantity, 0);
  if (currentQty === targetQty && feeLines.length <= 1) {
    return;
  }
  syncInProgress = true;
  try {
    for (let i = 1; i < feeLines.length; i++) {
      await cartChange(feeLines[i].key, 0);
    }
    const primaryLine = feeLines[0];
    if (targetQty === 0) {
      if (primaryLine) {
        await cartChange(primaryLine.key, 0);
      }
    } else if (!primaryLine) {
      await cartAdd(feeVariantId, targetQty);
    } else if (primaryLine.quantity !== targetQty) {
      await cartChange(primaryLine.key, targetQty);
    }
  } finally {
    syncInProgress = false;
  }
}
function cartChange(lineKey, quantity) {
  return new Promise((resolve) => {
    const body = new FormData();
    body.append("id", lineKey);
    body.append("quantity", String(quantity));
    const onEnd = (event) => {
      const { requestState } = event.detail ?? {};
      if (requestState?.requestType === "change") {
        document.removeEventListener("liquid-ajax-cart:request-end", onEnd);
        resolve();
      }
    };
    document.addEventListener("liquid-ajax-cart:request-end", onEnd);
    window.liquidAjaxCart.change(body);
  });
}
function cartAdd(variantId, quantity) {
  return new Promise((resolve) => {
    const body = new FormData();
    body.append("items[0][id]", String(variantId));
    body.append("items[0][quantity]", String(quantity));
    body.append("items[0][properties][_type]", "engraving-fee");
    const onEnd = (event) => {
      const { requestState } = event.detail ?? {};
      if (requestState?.requestType === "add") {
        document.removeEventListener("liquid-ajax-cart:request-end", onEnd);
        resolve();
      }
    };
    document.addEventListener("liquid-ajax-cart:request-end", onEnd);
    window.liquidAjaxCart.add(body);
  });
}
function initCartEngravingSync() {
  if (!document.querySelector("[data-engraving-fee-variant-id]")) {
    return;
  }
  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail ?? {};
    if (!requestState?.responseData?.ok) {
      return;
    }
    if (syncInProgress) {
      return;
    }
    syncFeeQty();
  });
}
function initCartVisibleCount() {
  function sync() {
    const feeVariantId = getFeeVariantId();
    const cart = window.liquidAjaxCart?.cart;
    if (!cart) {
      return;
    }
    let feeQty = 0;
    if (feeVariantId && cart.items) {
      feeQty = cart.items.filter((i) => i.variant_id === feeVariantId).reduce((sum, i) => sum + i.quantity, 0);
    }
    const visibleCount = Math.max(0, cart.item_count - feeQty);
    document.querySelectorAll("[data-cart-visible-count]").forEach((el) => {
      el.textContent = visibleCount;
    });
  }
  document.addEventListener("liquid-ajax-cart:request-end", sync);
}
if (document.querySelector("[data-dialog], [data-modal]")) {
  __vitePreload(() => import("./dialog-Bckxd7dC.js").then((n) => n.d), true ? __vite__mapDeps([0,1,2,3,4]) : void 0, import.meta.url);
}
if (document.querySelector("a[data-policy-modal]")) {
  __vitePreload(() => import("./policy-modal-JDZoVyjl.js"), true ? [] : void 0, import.meta.url);
}
if (document.readyState === "complete") {
  loadCarousel();
} else {
  window.addEventListener("load", loadCarousel);
}
function loadCarousel() {
  if (document.querySelector("carousel-embla")) {
    __vitePreload(() => import("./carousel-embla-DWvH-wV-.js"), true ? __vite__mapDeps([5,1,2,6]) : void 0, import.meta.url);
  }
}
if (document.querySelector("[data-predictive-search], predictive-search-component")) {
  __vitePreload(() => import("./predictive-search-C5KMDIlc.js").then((n) => n.p), true ? __vite__mapDeps([7,1,2,8,3]) : void 0, import.meta.url);
}
if (document.querySelector(".kaching-bundles-deal-block-settings")) {
  __vitePreload(() => import("./kaching-bundle-price-BbvRfB2p.js"), true ? __vite__mapDeps([9,2]) : void 0, import.meta.url);
}
function configureLiquidAjaxCart() {
  if (window.liquidAjaxCart && typeof window.liquidAjaxCart.conf === "function") {
    window.liquidAjaxCart.conf("binderFormatters", {
      money: (value) => formatMoney(parseFloat(value))
    });
    window.liquidAjaxCart.conf("updateOnWindowFocus", false);
    return true;
  }
  return false;
}
if (!configureLiquidAjaxCart()) {
  document.addEventListener("liquid-ajax-cart:init", () => {
    configureLiquidAjaxCart();
  });
}
initLiquidAjaxCartEventsBridge();
initCartEngravingSync();
initCartVisibleCount();
(function initPrefetchOnHover() {
  const prefetched = /* @__PURE__ */ new Set();
  let timer;
  let currentAnchor = null;
  document.addEventListener("mouseover", (e) => {
    const anchor = e.target.closest("a[href]");
    if (anchor === currentAnchor) {
      return;
    }
    clearTimeout(timer);
    currentAnchor = anchor;
    if (!anchor) {
      return;
    }
    const url = anchor.href;
    if (!url || !url.startsWith(location.origin) || prefetched.has(url)) {
      return;
    }
    timer = setTimeout(() => {
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.href = url;
      document.head.appendChild(link);
      prefetched.add(url);
    }, 200);
  });
})();
